import React, { useState, useEffect } from 'react';

export default function IndexSectionCookies7() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const cookieChoice = localStorage.getItem('cookieChoice');
        if (!cookieChoice) {
            // Show banner after a short delay
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAllow = () => {
        localStorage.setItem('cookieChoice', 'allowed');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieChoice', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <React.Fragment>
            <>
                <div className="fixed bottom-0 inset-x-0 z-50">
  <div className="container px-4 mx-auto mb-8">
    <div className="p-10 bg-gray-900 rounded-xl">
      <div className="max-w-3xl">
        <h3 className="mb-4 text-2xl font-semibold text-white font-heading">Cookie Policy</h3>
        <p className="mb-8 text-sm text-white opacity-40 leading-loose">We use cookies to personalise content, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners. If you want to change your cookie setting, please see the 'how to reject cookies' section of our privacy policy. Otherwise, if you agree to our use of cookies, please continue to use our website.</p>
        <button 
          onClick={handleAllow}
          className="inline-block px-8 py-4 mr-2 text-sm bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded transition duration-200"
        >
          Allow
        </button>
        <button 
          onClick={handleDecline}
          className="inline-block px-8 py-4 text-sm bg-transparent text-white font-semibold border border-blue-800 hover:border-blue-700 rounded transition duration-200"
        >
          Decline
        </button>
      </div>
    </div>
  </div>
</div>


            </>
        </React.Fragment>
    );
}

